import React from 'react';

const DebugToken = () => {
  const token = localStorage.getItem('token');
  return (
    <div style={{background: '#222', color: '#fff', padding: 16, borderRadius: 8, margin: 16}}>
      <h3>Token JWT no LocalStorage</h3>
      <pre>{token ? token : 'Nenhum token encontrado. Faça login.'}</pre>
    </div>
  );
};

export default DebugToken;
